// extracted by mini-css-extract-plugin
export default {"footer":"AdminApiView-module__footer--qx8Pr","footerContact":"AdminApiView-module__footerContact--oxKRu","animatedBackground":"AdminApiView-module__animatedBackground--rWF0o"};